import { render, staticRenderFns } from "./List-Permission.vue?vue&type=template&id=311ee55d&scoped=true"
import script from "./List-Permission.vue?vue&type=script&lang=js"
export * from "./List-Permission.vue?vue&type=script&lang=js"
import style0 from "./List-Permission.vue?vue&type=style&index=0&id=311ee55d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ee55d",
  null
  
)

export default component.exports